import React from "react";

function Icon(props: any) {
  return (
    <svg
      x="0"
      y="0"
      enableBackground="new 0 0 510 510"
      version="1.1"
      viewBox="0 0 510 510"
      xmlSpace="preserve"
      {...props}
    >
      <path
        fill="currentColor"
        d="M735 4466c-67-29-105-105-90-183 6-34 101-133 848-880l842-843-842-842C579 802 627 857 645 763c9-49 69-109 118-118 94-18 32-74 1029 923 815 816 917 921 923 955 18 94 73 33-913 1021-529 529-920 914-939 922-40 17-89 17-128 0z"
        transform="matrix(.1 0 0 -.1 0 512)"
      ></path>
      <path
        fill="currentColor"
        d="M2495 4466c-67-29-105-105-90-183 6-34 101-133 848-880l842-843-842-842c-914-916-866-861-848-955 9-49 69-109 118-118 94-18 32-74 1029 923 815 816 917 921 923 955 18 94 73 33-913 1021-529 529-920 914-939 922-40 17-89 17-128 0z"
        transform="matrix(.1 0 0 -.1 0 512)"
      ></path>
    </svg>
  );
}

export default Icon;
